import { z } from 'zod';
import { isoDateTimeSchema } from '../common/primitives.js';
import { bilingualTextInputSchema, bilingualTextSchema, employeeRefSchema, } from '../common/refs.js';
/**
 * إعدادات الحوالات (transfers.md section 10): organisation name for the
 * receipt, نص الإقرار shown before the signature, the receipt footer, and
 * إرسال نسخة للمرسل (off by default) and تأكيد رقم الهاتف برمز واتساب (off by
 * default). Every text exists in Arabic and English.
 */
export const settingsViewSchema = z.object({
    organisationName: bilingualTextSchema,
    declarationText: bilingualTextSchema,
    receiptFooter: bilingualTextSchema,
    sendSenderCopy: z.boolean(),
    /**
     * تأكيد رقم الهاتف برمز واتساب (customers.md section 10.1, off by default):
     * the party present is verified with a WhatsApp code before posting and
     * before an edit that changes that party's phone.
     */
    phoneVerification: z.boolean(),
    updatedAt: isoDateTimeSchema.nullable(),
    updatedBy: employeeRefSchema.nullable(),
});
/** PATCH /settings — partial. */
export const updateSettingsSchema = z
    .object({
    organisationName: bilingualTextInputSchema.refine((v) => v.ar.length > 0 && v.en.length > 0, {
        message: 'enter the name in Arabic and English',
    }),
    declarationText: bilingualTextInputSchema,
    receiptFooter: bilingualTextInputSchema,
    sendSenderCopy: z.boolean(),
    phoneVerification: z.boolean(),
})
    .partial();
//# sourceMappingURL=contract.js.map